interface NumericInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  name?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  unit?: string;
  min?: number;
  max?: number;
  step?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  testId?: string;
}

export function NumericInput({
  label,
  value,
  onChange,
  name,
  required = false,
  error,
  helperText,
  unit,
  min,
  max,
  step = 1,
  onKeyDown,
  testId,
}: NumericInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue === '' || /^\d*\.?\d*$/.test(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <div className="flex flex-col">
      <label className="label-compact block">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      <div className="flex">
        <input
          type="text"
          inputMode="decimal"
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          min={min}
          max={max}
          step={step}
          data-testid={testId}
          className={`input-compact flex-1 border ${
            unit ? 'rounded-l-md border-r-0' : 'rounded-md'
          } transition-colors ${
            error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
          }`}
        />
        {unit && (
          <div className="input-compact px-3 bg-gray-50 border border-gray-300 rounded-r-md text-gray-700 flex items-center text-sm">
            {unit}
          </div>
        )}
      </div>
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
      {helperText && !error && (
        <p className="text-xs text-gray-500 mt-1">{helperText}</p>
      )}
    </div>
  );
}
